jQuery(document).ready(function () {
  jQuery("#casestudy_clientbase,#casestudy_industry").change(function () {
    // console.log('hi');
    var clientbase_value = jQuery("#casestudy_clientbase").val();
    var industry_value = jQuery("#casestudy_industry").val();
    var casestudy_url =
      window.location.href.replace(/\?.*$/, "") +
      "/?industry=" +
      industry_value +
      "&clientbase=" +
      clientbase_value;
    window.location = casestudy_url;
  });

  jQuery("#reset_casestudy_filter").click(function () {
    var without_filter_url = window.location.href.replace(/\?.*$/, "");
    window.location = without_filter_url;
  });

  card_effect_slider();
});

// card effect slider js
function card_effect_slider() {
  var $card = jQuery(".feature_slider_images0 .card");
  var lastCard = jQuery(".feature_slider_images0 .card-list .card").length - 1;
  // console.log(lastCard);
  jQuery(".feature_slider_images0 .card").last().addClass("activeNow");

  jQuery(".feature_slider_images0 .next").click(function (e) {
    e.preventDefault();
    var prependList = function () {
      if (jQuery(".feature_slider_images0 .card").hasClass("activeNow")) {
        var $slicedCard = jQuery(".feature_slider_images0 .card")
          .slice(lastCard)
          .removeClass("transformThis activeNow");
        jQuery(".feature_slider_images0 ul").prepend($slicedCard);
      }
    };
    jQuery(".feature_slider_images0 li")
      .last()
      .removeClass("transformPrev")
      .addClass("transformThis")
      .prev()
      .addClass("activeNow");
    setTimeout(function () {
      prependList();
    }, 150);
  });

  jQuery(".feature_slider_images0 .prev").click(function (e) {
    e.preventDefault();
    var appendToList = function () {
      if (jQuery(".feature_slider_images0 .card").hasClass("activeNow")) {
        var $slicedCard = jQuery(".feature_slider_images0 .card")
          .slice(0, 1)
          .addClass("transformPrev");
        jQuery(".feature_slider_images0 .card-list").append($slicedCard);
      }
    };
    jQuery(".feature_slider_images0 li")
      .removeClass("transformPrev")
      .last()
      .addClass("activeNow")
      .prevAll()
      .removeClass("activeNow");
    setTimeout(function () {
      appendToList();
    }, 150);
  });
}



// WEBPACK FOOTER //
// ./scripts/casestudy/script.js